
import request from "../utils/request";

export function wawalist(data) {
    return request({
        url: "/finance/wawalist",
        data: data,
    });
}

export function coinlist(data) {
    return request({
        url: "/finance/coinlist",
        data: data,
    });
}

export function realtimeCoinlist(data) {
    return request({
        url: "/finance/realtimeCoinlist",
        data: data,
    });
}

export function mgclist(data) {
    return request({
        url: "/finance/mgclist",
        data: data,
    });
}

export function candylist(data) {
    return request({ url: "/finance/candylist", data });
}


